module.exports = __webpack_public_path__ + "app/themes/vwfs/sme-price-list-assets/img/luton-active.f2d5c6e8.svg";